import makeGriffinServiceRequest from '../../services/makeGriffinServiceRequest';
import {
    ADD_REMOVE_OR_EDIT_URL_PREFIX,
    REMOVE_FROM_CALENDAR_RELATIVEPATH,
} from '../../helpers/GriffinConstants';
/**
 * Handler for removing Txp event from calendar
 */
export default function onRemoveFromCalendarClickHandler(itemId: string) {
    // TODO: Add timeout for griffin call VSTS#52270
    return makeGriffinServiceRequest(
        itemId,
        ADD_REMOVE_OR_EDIT_URL_PREFIX,
        REMOVE_FROM_CALENDAR_RELATIVEPATH
    );
}
